<table mat-table [dataSource]="linhas" class="mat-elevation-z8">
  <ng-container matColumnDef="nome">
    <th mat-header-cell *matHeaderCellDef i18n="@@nome">Nome</th>
    <td mat-cell *matCellDef="let nome" data-label="Nome" i18n-data-label="@@nome">{{ nome }}</td>
  </ng-container>
  <tr mat-header-row *matHeaderRowDef="linhaColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: linhaColumns;"></tr>
</table>